module.exports = __webpack_public_path__ + "img/04.7d1eece9.png";